import { useContext } from "react";

import { useMutation } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

import toGlobalId from "scenes/Hubly/components/Workspace/api/helper";
import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

const mutationFactory = () => {
  const query = `mutation assignTaskToConditionsGroup($taskId: ID!, $conditionsGroupId: ID!) {
    assignTaskToConditionsGroup(taskId: $taskId, conditionsGroupId: $conditionsGroupId) {
      successMessage
    }
  }`;

  const resolver = ({ data: { assignTaskToConditionsGroup } }) => {
    return { data: assignTaskToConditionsGroup };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

export function useAssignTaskToConditionsGroupAction() {
  const mutate = useMutation(mutationFactory);
  const { fireError } = useContext(ToasterContext);

  return (taskId, conditionsGroupId) => {
    return mutate({
      taskId: toGlobalId("Task", taskId),
      conditionsGroupId: conditionsGroupId,
    })
      .then((resp) => {
        return resp;
      })
      .catch((e) => {
        fireError(
          Array.isArray(e) && e[0]?.message
            ? e[0].message
            : "Failed to assign task to conditions group, please retry or contact support for assistance",
          e
        );
      });
  };
}
export default useAssignTaskToConditionsGroupAction;
